class ThumbnailsScrollable extends HTMLElement {
  constructor() {
    super();
    this.$scrollCarousel = null;
    this.$carouselNavigation = null;
  }

  connectedCallback() {
    this.$scrollCarousel = document.querySelector('[data-product-carousel]');
    this.$carouselNavigation = this.querySelector('product-gallery-navigation');
    if (isNullOrUndefined(this.$scrollCarousel) || isNullOrUndefined(this.$carouselNavigation)) return;
    this.initialize();
  }

  initialize() {
    if (this.$carouselNavigation.clientHeight > this.$scrollCarousel.clientHeight) {
      this.$carouselNavigation.style.height = this.$scrollCarousel.clientHeight + 'px';
      this.initArrows();
    }
    // this.$carouselNavigation.classList.remove('opacity-0');
  }

  initArrows() {
    this.$arrowTop = this.querySelector('.scroll-arrow-top');
    this.$arrowBottom = this.querySelector('.scroll-arrow-bottom');
    if (isNullOrUndefined(this.$arrowTop) || isNullOrUndefined(this.$arrowBottom)) return;
    this.toggleArrowTop();
    this.toggleArrowBottom();
    this.$arrowTop.addEventListener('click', this.handleArrowClick.bind(this));
    this.$arrowBottom.addEventListener('click', this.handleArrowClick.bind(this));
    this.$carouselNavigation.addEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    this.toggleArrowTop();
    this.toggleArrowBottom();
  }

  toggleArrowTop () {
    this.$arrowTop.hidden = this.$carouselNavigation.scrollTop < 10;
  }

  toggleArrowBottom () {
    this.$arrowBottom.hidden = Math.ceil(this.$carouselNavigation.scrollTop + this.$carouselNavigation.clientHeight) >= this.$carouselNavigation.scrollHeight
  }

  handleArrowClick(e) {
    const direction = e.currentTarget.dataset.direction;
    this.$carouselNavigation.scrollBy({
      top: direction === 'up' ? -this.$carouselNavigation.clientHeight / 2 : this.$carouselNavigation.clientHeight / 2,
      behavior: 'smooth'
    });
  }
}

if (!customElements.get('thumbnails-scrollable')) {
  customElements.define('thumbnails-scrollable', ThumbnailsScrollable);
}
